import "core-js/modules/es.array.push.js";
import { paidList, getPayURL } from './request';
import moment from 'moment';
import { areaData } from '@/utils/city';
import { columns, statusSelectList } from './utils';
export default {
  data() {
    return {
      areaData,
      statusSelectList,
      columns,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      form: {
        city: [],
        status: 'PAY_INITIAL_STATUS',
        time: []
      },
      tableData: [],
      selectedRowKeys: [],
      disabledPay: false
    };
  },
  created() {
    this.searchFun();
  },
  computed: {
    isDisabled() {
      if (this.form.city.length && this.form.status == 'PAY_INITIAL_STATUS') {
        return false;
      }
      return true;
    }
  },
  methods: {
    searchFun() {
      this.selectedRowKeys = [];
      this.pagination.current = this.pagination.page = 1;
      this.getListData();
    },
    async getListData() {
      let params = {
        startTime: this.form.time.length ? moment(this.form.time[0]).format('yyyy-MM-DD') + ' 00:00:00' : '',
        endTime: this.form.time.length ? moment(this.form.time[1]).format('yyyy-MM-DD') + ' 23:59:59' : '',
        insuredProvince: this.form.city[0],
        insuredCity: this.form.city[1],
        insuredArea: this.form.city[2],
        status: this.form.status,
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      };
      const {
        items,
        totalNum
      } = await paidList(params);
      this.tableData = items;
      this.pagination.total = totalNum;
      let lastPage = Math.ceil(this.pagination.total / this.pagination.pageSize);
      if (this.pagination.page === lastPage + 1 && this.pagination.total % (this.pagination.pageSize * (this.pagination.page - 1)) === 0) {
        this.pagination.page -= 1;
        this.pagination.current -= 1;
        this.getListData();
      }
    },
    tablePageChange(val) {
      this.pagination = val;
      this.pagination.page = val.current;
      this.selectedRowKeys = [];
      this.getListData();
    },
    onSelectChange(val, all) {
      this.selectedRowKeys = val;
    },
    onCheckboxProps(record) {
      return {
        props: {
          disabled: record.status == 'PAY_INITIAL_STATUS' ? false : true
        }
      };
    },
    async BulkPay(key, record) {
      this.disabledPay = true;
      let customerPayId = [];
      if (key == 1) {
        if (record.status == 'PAY_TOBE_PAID' && record.thirdPayUrl) {
          // location.href = record.thirdPayUrl;
          this.searchFun();
          window.open(record.thirdPayUrl);
          this.disabledPay = false;
          return;
        }
        customerPayId.push(record.id);
      } else {
        if (!this.selectedRowKeys.length) {
          return this.$message.warning(this.$t('请选择') + this.$t('要支付的保单数据'));
        }
        customerPayId = this.selectedRowKeys;
      }
      const res = await getPayURL({
        customerPayId
      });
      this.searchFun();
      window.open(res.thirdPayUrl);
      this.disabledPay = false;
    },
    disabledDate(current) {
      return current && current >= moment().endOf('days');
    },
    onChangeTime() {
      var _this$form$time$;
      if (((_this$form$time$ = this.form.time[1]) === null || _this$form$time$ === void 0 ? void 0 : _this$form$time$.diff(this.form.time[0], 'days')) > 30) {
        this.form.time = [];
        this.$message.warning(this.$t('查询范围最长不超过30天'));
      }
    }
  }
};